//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services.js";
// import fileDownload from "js-file-download" ;
import TraitsTable from "@/pages/ProductManagement/components/traitsTable.vue";
import LogisticsTable from "@/pages/ProductManagement/components/logisticsTable.vue";
import BusinessTable from "@/pages/ProductManagement/components/businessTable.vue";
import TraitsTab from "@/pages/ProductManagement/components/traitsTab.vue";
import LogisticsTab from "@/pages/ProductManagement/components/logisticsTab.vue";
import PriceHistoryTab from "@/pages/ProductManagement/components/priceHistoryTab.vue";
import BusinessTab from "@/pages/ProductManagement/components/businessTab.vue";
// import TagsTab from "@/pages/ProductManagement/components/tagsTab.vue";
import FileSaver from "file-saver";
import { Feedback } from "@/utils/notify-toaster.js";


export default {
  name: "ProductManagement",
  components: {
    LogisticsTable,
    TraitsTable,
    BusinessTable,
    TraitsTab,
    LogisticsTab,
    PriceHistoryTab,
    BusinessTab,
  },
  // TagsTab,
  mounted: function () {
    this.productsList = [];
    this.isLoading = true;
    BackendServices.getProducts().then((response) => {
      this.recordsTotal = Number(response.headers["x-total-count"]);
      this.productsList = response.data;
      this.isLoading = false;
    });
  },
  data: () => ({
    traitsForm: true,
    logisticsForm: true,
    productsList: [],
    filterState: null,
    tableTab: "traits",
    tab: "traits",
    rightSidePane: false,
    product: {},
    isLoading: false,
    recordsTotal: 0,
  }),
  methods: {
    successMessage: function () {
      this.$q.notify({
        message: "Operação realizada com sucesso.",
        color: "green-9",
      });
    },
    createNewProduct: function () {
      this.rightSidePane = true;
      this.traitsForm = false;
      this.logisticsForm = true;
      BackendServices.getProductHierarchyLevels().then(({ data }) => {
        this.product = {
          can_delete: true,
          ready: false,
          hierarchy: [
            { id: null, name: null, level_id: data[0].id, parent_id: null },
          ],
          // tags: [],
        };
        // for (let i = 0; i < 5; i++) {
        //   this.product.tags.push({
        //     id: null,
        //     key: null,
        //     value: null,
        //     tag_type: "user",
        //   });
        // }
      });
    },
    askForData: function (event) {
      this.isLoading = true;
      BackendServices.getProducts(
        event.pagination,
        event.filter,
        event.sort,
        false,
        event.search
      ).then((response) => {
        this.recordsTotal = response.headers["x-total-count"];
        if (response.headers["x-total-count"] === "0") {
          this.productsList = [];
        } else {
          this.productsList = response.data;
        }
        this.isLoading = false;
      });
    },
    openExistingProduct: function (event) {
      this.rightSidePane = true;
      this.product = event;
      // let newItems =
      //   5 -
      //   this.product.tags.filter(
      //     (i) => i.tag_type === "user" && i.key != null && i.value != null
      //   ).length;
      // let totalUserTags = this.product.tags.filter(
      //   (i) => i.tag_type === "user"
      // ).length;
      // for (let i = 0; i < newItems && totalUserTags < 5; i++) {
      //   this.product.tags.push({
      //     id: null,
      //     key: null,
      //     value: null,
      //     tag_type: "user",
      //   });
      // }
      this.traitsForm = true;
      this.logisticsForm = true;
    },
    closeForm: function () {
      this.rightSidePane = false;
      this.product = {};
    },
    saveProduct: async function () {
      // this.product.tags = this.product.tags.filter(
      //   (item) => item.key && item.value
      // );
      let operation = null
      if (!this.product.id) {
        operation = await BackendServices.createNewProduct(this.product)
      } else {
        operation = await BackendServices.updateManagementProduct(this.product);
      }
      if (operation && (operation.status == 200 || operation.status == 201)) {
        this.rightSidePane = false;
        Feedback.sucess("Produto actualizado com sucesso.");
        this.isLoading = true;
        BackendServices.getProducts().then((response) => {
          this.recordsTotal = Number(response.headers["x-total-count"]);
          this.productsList = response.data;
          this.isLoading = false;
        });
      }
    },
    removeProduct: function (product) {
      BackendServices.deleteProduct(product)
        .then(() => window.location.reload())
        .catch((error) =>
          this.$q.notify({ message: error.response.data.error, color: "red" })
        );
    },
    exportFilteredProducts: function () {
      let filters = [];
      if (this.filterState) {
        if (this.filterState.filters) {
          Object.values(this.filterState.filters).forEach((value) => {
            if (value.include && value.include.length > 0) {
              filters.push({ key: value.column_key, values: value.include });
            }
          });
        }
      }
      BackendServices.downloadProductList(filters.length ? filters : null).then(
        (response) => {
          FileSaver.saveAs(response.data, "ManifestoProdutos.xlsx");
        }
      );
    },
  },
  watch: {
    product: {
      deep: true,
      handler: function (newValue) {
        if (
          this.product.hierarchy &&
          this.product.hierarchy[0] &&
          this.product.hierarchy[0].id
        ) {
          let onlyIds = newValue.hierarchy.filter((element) => element.id);
          this.product.least_hierarchy_level_id =
            newValue.hierarchy[onlyIds.length - 1].id;
        } else {
          this.product.least_hierarchy_level_id = null;
        }
      },
    },
  },
};
